@if (loginDisplay()) {
  <!-- `bg-surface-app` : fond gris du design system, sur lequel les tuiles
       blanches (`.body-sub-container`) ressortent. Le shell de V3 le porte aussi. -->
  <div class="flex h-screen w-screen overflow-hidden bg-surface-app">
    <!-- Barre de navigation du design system. Les entrees viennent de
         NAVIGATION_BACKSTAGE, filtrees par les droits applicatifs ; le pied est
         projete (la source y monte le selecteur de tenant et le menu utilisateur
         du Manager, adosses a l'OIDC — voir PROVENANCE.md). -->
    <!-- Le logo porte un nom de fichier sans « & » : dans un attribut HTML ce
         caractere amorce une entite, ce qui cassait le chargement de l'image. -->
    <app-navigation-sidebar
      [navigation]="navigationAutorisee()"
      logoSrc="assets/img/backstage-logo.svg"
      [showLanguageToggle]="false"
      [showThemeToggle]="false"
    >
      <!-- Pied de barre : reprise de l'ancien bloc (utilisateur, deconnexion,
           logo, version). Les couleurs passent aux jetons du kit — l'original
           etait en blanc sur une barre sombre. -->
      <div sidebar-account class="pied-compte">
        <div class="pied-compte__utilisateur">{{ user() }}</div>

        <button type="button" class="pied-compte__deconnexion" (click)="logout()">Se déconnecter</button>

        <!-- `src` et non `ngSrc` : `NgOptimizedImage` exige une taille connue
             (`width`/`height` ou `fill`) et n'apporte rien a un logo statique
             servi depuis `assets/`. Retire de tout le depot avec ce lot. -->
        <img class="pied-compte__logo" alt="Tick&Live" src="assets/img/tickandlive-logo_white.svg" />

        <p class="pied-compte__version">
          v{{ version }}
          <app-icon
            name="info"
            routerLink="version"
            class="pied-compte__note"
            appTooltip="Note de version"
            appFeatureEnabled="Version"
          />
        </p>
      </div>
    </app-navigation-sidebar>

    <!-- `overflow-y-auto` et non `overflow-hidden` comme dans V3 : la-bas chaque
         page gere sa propre zone de defilement, ce que les ecrans BackStage ne
         font pas — sans cela plus rien ne defile. -->
    <main class="isolate flex flex-1 flex-col overflow-y-auto">
      <router-outlet />
    </main>
  </div>
} @else {
  <app-login></app-login>
}
@if (isLoading()) {
  <app-chargement></app-chargement>
}
<app-toast-container />
